import RootOfflineTableMixin from 'GroomyRoot/mixins/OfflineTable.js'

export default {
    mixins: [RootOfflineTableMixin]
}